import React from "react";

const AppleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84833 2.39468C9.40585 1.76093 9.78166 0.878243 9.67882 0C8.87539 0.0300003 7.90339 0.503365 7.32731 1.13636C6.80999 1.69811 6.3584 2.5957 6.47981 3.4567C7.37602 3.52194 8.2908 3.02917 8.84833 2.39468ZM10.858 7.96882C10.8805 10.2391 12.9768 10.9943 13 11.004C12.983 11.0573 12.6652 12.0801 11.8958 13.1376C11.23 14.0511 10.5395 14.9609 9.45147 14.9804C8.38282 14.9991 8.03871 14.3849 6.81618 14.3849C5.59441 14.3849 5.21242 14.9608 4.20099 14.999C3.15089 15.0358 2.35056 14.0107 1.68013 13.1002C0.308356 11.238 -0.739421 7.83764 0.667927 5.54265C1.36696 4.40341 2.61579 3.68088 3.9721 3.66288C5.00286 3.64413 5.97641 4.31474 6.60662 4.31474C7.23684 4.31474 8.41994 3.50849 9.66335 3.62699C10.1838 3.64724 11.6452 3.82418 12.5832 5.11492C12.5074 5.15917 10.8395 6.07134 10.858 7.96882Z"
        fill="white"
      />
    </svg>
  );
};

export default AppleIcon;
